import { Box, Group, MantineColor, Text } from '@mantine/core';

import { MenuTemplateStateEnum } from '@/api';

import { stateLabel } from '../helpers';

type MenuStatusBadgeProps = {
  state: MenuTemplateStateEnum;
};

const DOT_COLOR_BY_STATE: Record<MenuTemplateStateEnum, MantineColor> = {
  [MenuTemplateStateEnum.PUBLISHED]: 'green.6',
  [MenuTemplateStateEnum.APPROVED]: 'blue.6',
  [MenuTemplateStateEnum.PENDING_APPROVAL]: 'yellow.6',
  [MenuTemplateStateEnum.DRAFT]: 'gray.5',
};

export const MenuStatusBadge: React.FC<MenuStatusBadgeProps> = ({ state }) => (
  <Group gap={6} wrap="nowrap" align="center">
    <Box w={8} h={8} bg={DOT_COLOR_BY_STATE[state]} style={{ borderRadius: '50%' }} />
    <Text size="xs" fw={600} tt="uppercase" c={DOT_COLOR_BY_STATE[state]}>
      {stateLabel(state)}
    </Text>
  </Group>
);

